const MicrosoftIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 23"
      width="23"
      height="23"
      {...props}
    >
      <path fill="#f1511b" d="M11.5 0h-11.5v11.5h11.5z" />
      <path fill="#80cc28" d="M23 0h-11.5v11.5h11.5z" />
      <path fill="#00adef" d="M11.5 11.5h-11.5v11.5h11.5z" />
      <path fill="#fbbc09" d="M23 11.5h-11.5v11.5h11.5z" />
    </svg>
  );
};

export default MicrosoftIcon;
